'use strict';
angular.module('app')
.factory('chunk', function ()
{
    return function chunk(arr, chunkSize)
    {
        var r = [];
        for (var i = 0, len = arr.length; i < len; i += chunkSize) {
            r.push(arr.slice(i, i + chunkSize));
        }

        return r;
    }
});
